var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"all-trade-tab rounded-0",attrs:{"elevation":"0","color":_vm.$vuetify.theme.dark ? '#131c29' : '#E0EAF2'}},[_c('ConditionOneTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }